import React from "react";

const Supporto = () => {
  return (
    <div>
      {/* Prima sezione con immagine undraw_contact-us.svg */}
<section className="astronaut_section pb-80 pt-10 bg-[#fbfef5] min-h-[800px] bg-no-repeat bg-center bg-cover">
  <div className="container-xl mx-auto px-0 flex justify-between items-center max-w-7xl max-w-[85%] gap-15 flex-col lg:flex-row">
    
    {/* Left side */}
    <div className="w-full lg:w-1/2 text-lg mb-8 lg:mb-0">
      <h1 className="titolo-style mb-6 text-left">
        <span className="text-[#131904]" style={{ marginBottom: '0px', display: 'block', fontSize: '48px' }}>
          Hai qualche dubbio?
        </span>
        <span className="text-[#94c41c]" style={{ marginTop: '0px', display: 'block', fontSize: '48px' }}>
          Visita il centro assistenza.
        </span>
      </h1>
      <p className="regular-text text-left text-[#131904] max-w-full mx-auto block" style={{ fontSize: '20px' }}>
        Per qualsiasi dubbio riguardante i domini, Seeurl o i servizi offerti, ti consigliamo di visitare prima il nostro centro assistenza.
        <br /><br />
        Se non trovi la risposta che cerchi, il nostro team di supporto è sempre pronto ad aiutarti.
      </p>
      
      {/* Pulsante Vai al centro assistenza */}
      <div className="text-left"> {/* Aggiungi un contenitore per forzare l'allineamento a sinistra */}
        <a 
          href="/centro-assistenza" 
          className="inline-block mt-6 px-8 py-4 text-2xl font-semibold text-white bg-[#94c41c] hover:bg-black hover:text-white border-2 border-transparent rounded-full transition-all duration-300"
          style={{
            borderRadius: '20px',
          }}
        >
          Vai al centro assistenza
          <span className="inline-block ml-2 text-white">
            ⮕
          </span>
        </a>
      </div>

    </div>

    {/* Right side (Image) */}
    <div className="w-full lg:w-1/2">
      <img
        src="/static/immagine_contatti_1.svg"
        alt="Digital Domain"
        className="max-w-full h-auto"
      />
    </div>
  </div>
</section>

      {/* Separatore ondulato tra le due parti */}
      <div className="relative bg-[#fbfef5] mt-10">
        <div className="absolute bottom-0 left-0 w-full z-10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            height="120"
            width="100%"
            preserveAspectRatio="none"
            className="block w-full h-full"
          >
            <path
              fill="#f3f9e4"
              d="M0,60 C650,-100 800,180 1200,60 L1200,120 L0,120 Z"
            />
          </svg>
        </div>
      </div>

      {/* Seconda sezione con immagine undraw_contact-us.svg */}
      <section className="astronaut_section pb-40 pt-0 bg-[#f3f9e4] min-h-[800px] bg-no-repeat bg-center bg-cover">
        <div className="container-xl mx-auto px-0 flex justify-between items-center max-w-7xl max-w-[85%] gap-15 flex-col lg:flex-row">
          
          {/* Left side (Image) */}
          <div className="w-full lg:w-1/2 mb-8 lg:mb-0">
            <img
              src="/static/immagine_contatti_2.svg"
              alt="Digital Domain"
              className="max-w-full h-auto"
            />
          </div>

          {/* Right side (Text) */}
          <div className="w-full lg:w-1/2 text-lg">
            <h1 className="titolo-style mb-6 text-left">
              <span className="text-[#131904]" style={{ marginBottom: '0px', display: 'block', fontSize: '48px' }}>
                Contatti
              </span>
            </h1>

            {/* Description Text */}
            <p className="regular-text text-left text-[#131904] max-w-full mx-auto block" style={{ fontSize: '25px' }}>
              Il nostro team di supporto è sempre a tua disposizione.
            </p>

            {/* Icons and Titles */}
            <div className="mt-12 space-y-8">
              {/* Icon 1 - Email */}
              <div className="flex flex-col items-start mb-6">
                {/* Contenuto icon + titolo */}
                <div className="flex items-center mb-2">
                  <i className="fas fa-2x fa-envelope text-[#131904]"></i>
                  <span className="font-bold text-[#131904] ml-4" style={{ fontSize: '23px' }}>Email</span>
                </div>

                {/* Paragrafo sotto il titolo */}
                <p className="regular-text text-left text-[#131904]" style={{ fontSize: '22px' }}>
                  Contattaci via email per qualsiasi domanda o richiesta.
                </p>
              </div>

              {/* Icon 2 - Phone */}
              <div className="flex flex-col items-start mb-6">
                {/* Contenuto icon + titolo */}
                <div className="flex items-center mb-2">
                  <i className="fas fa-2x fa-phone-alt text-[#131904]"></i>
                  <span className="font-bold text-[#131904] ml-4" style={{ fontSize: '23px' }}>Telefono</span>
                </div>

                {/* Paragrafo sotto il titolo */}
                <p className="regular-text text-left text-[#131904]" style={{ fontSize: '22px' }}>
                  Per urgenti richieste, puoi contattarci telefonicamente.
                </p>
              </div>

              {/* Icon 3 - Location */}
              <div className="flex flex-col items-start mb-6">
                {/* Contenuto icon + titolo */}
                <div className="flex items-center mb-2">
                  <i className="fas fa-2x fa-map-marker-alt text-[#131904]"></i>
                  <span className="font-bold text-[#131904] ml-4" style={{ fontSize: '23px' }}>Posizione</span>
                </div>

                {/* Paragrafo sotto il titolo */}
                <p className="regular-text text-left text-[#131904]" style={{ fontSize: '22px' }}>
                  Visita la nostra sede per qualsiasi assistenza.
                </p>
              </div>

              {/* Icon 4 - Pin */}
              <div className="flex flex-col items-start mb-6">
                {/* Contenuto icon + titolo */}
                <div className="flex items-center mb-2">
                  <i className="fas fa-2x fa-map-marker-alt text-[#131904]"></i>
                  <span className="font-bold text-[#131904] ml-4" style={{ fontSize: '23px' }}>Posizione</span>
                </div>

                {/* Paragrafo sotto il titolo */}
                <p className="regular-text text-left text-[#131904]" style={{ fontSize: '22px' }}>
                  Se vuoi vedere i nostri uffici, ecco la posizione precisa.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sezione Richiamo Compra Dominio */}
      <section className="bg-[#95c11f] text-center py-20 pt-40 pb-40">
  <div className="container-xl mx-auto px-6 max-w-3xl max-w-[85%]">
    {/* Titolo con doppia riga e doppio colore */}
    <h2 className="titolo-style text-center text-5xl text-black mb-6">
      <span className="block text-[#131904]" style={{ marginBottom: '10px', display: 'block', fontSize: '55px' }}>
        Cerca, trova, acquista.
      </span>
      <span className="block text-[#fbfef5]" style={{ marginTop: '10px', display: 'block', fontSize: '55px' }}>
        Ottieni il dominio perfetto!
      </span>
    </h2>

    {/* Search Form */}
    <div className="mt-12 flex justify-center">
      <form
        action="../search-results"
        acceptCharset="UTF-8"
        method="get"
        className="w-full max-w-[100%] sm:max-w-[70%] md:max-w-[50%] lg:max-w-[40%] xl:max-w-[35%]"
      >
        <div
          className="relative flex overflow-hidden h-18 border-2 bg-[#fbfef5]"
          style={{
            borderRadius: '20px', // Applica la rotondità direttamente al div
          }}
        >
          <input
            type="text"
            name="terms"
            id="terms"
            placeholder="Cerca qui il tuo dominio ideale..."
            className="flex-grow px-6 py-4 text-xl text-[#4b6f32] focus:outline-none h-full placeholder-white"
            style={{ fontSize: '18px', color: '#869d4a' }}
          />
          <button
            type="submit"
            style={{
              color: '#869d4a',
              padding: '0px 20px',
              borderTopLeftRadius: '0',
              borderBottomLeftRadius: '0',
              borderTopRightRadius: '20px',
              borderBottomRightRadius: '20px',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'background-color 0.3s',
            }}
          >
            <svg
              style={{ width: '35px', height: '35px' }}
              fill="none"
              stroke="#869d4a"
              strokeWidth="1.5"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="11" cy="11" r="7" strokeLinecap="round" strokeLinejoin="round" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>
      </form>
    </div>
  </div>
</section>
    </div>
  );
};

export default Supporto;
